import { useQuery } from '@apollo/client/react';
import { PassesList } from '@drycut/booking-components';
import { GetStoreDocument } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useNavigate, useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function Passes(): React.ReactNode {
  useDocumentTitle('DRYCUT - DRYPASS');

  const navigate = useNavigate();
  const { slug } = useParams() as { slug: string };
  const { data, loading } = useQuery(GetStoreDocument, { variables: { slug } });

  if (loading) {
    return <Loader />;
  }

  if (!data?.store || !data.store.active) {
    navigate('/not-found');
    return null;
  }

  return <PassesList storeSlug={slug} />;
}
